// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// ILendingPoolAddressesProvider https://polygonscan.com/address/0xd05e3E715d945B59290df0ae8eF85c1BdB684744
export const POOL_ADDRESSES_PROVIDER = '0xd05e3E715d945B59290df0ae8eF85c1BdB684744';

// ILendingPool https://polygonscan.com/address/0x8dFf5E27EA6b7AC08EbFdf9eB090F32ee9a30fcf
export const POOL = '0x8dFf5E27EA6b7AC08EbFdf9eB090F32ee9a30fcf';

// https://polygonscan.com/address/0x1685D81212580DD4cDA287616C2f6F4794927e18
export const POOL_IMPL = '0x1685D81212580DD4cDA287616C2f6F4794927e18';

// ILendingPoolConfigurator https://polygonscan.com/address/0x26db2B833021583566323E3b8985999981b9F1F3
export const POOL_CONFIGURATOR = '0x26db2B833021583566323E3b8985999981b9F1F3';

// https://polygonscan.com/address/0x56C8Aa7e4fCAbaaD5e87d6847D0901134939A13a
export const POOL_CONFIGURATOR_IMPL = '0x56C8Aa7e4fCAbaaD5e87d6847D0901134939A13a';

// IAaveOracle https://polygonscan.com/address/0x0229F777B0fAb107F9591a41d5F02E4e98dB6f2d
export const ORACLE = '0x0229F777B0fAb107F9591a41d5F02E4e98dB6f2d';

// ILendingRateOracle https://polygonscan.com/address/0x17F73aEaD876CC4059089ff815EDA37052960dFB
export const LENDING_RATE_ORACLE = '0x17F73aEaD876CC4059089ff815EDA37052960dFB';

// IAaveProtocolDataProvider https://polygonscan.com/address/0x7551b5D2763519d4e37e8B81929D336De671d46d
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x7551b5D2763519d4e37e8B81929D336De671d46d';

// https://polygonscan.com/address/0x94d977c42C7880EC05aF5Ba6d913785462bf9346
export const LENDING_POOL_COLLATERAL_MANAGER = '0x94d977c42C7880EC05aF5Ba6d913785462bf9346';

// https://polygonscan.com/address/0xDf7d0e6454DB638881302729F5ba99936EaAB233
export const POOL_ADMIN = '0xDf7d0e6454DB638881302729F5ba99936EaAB233';

// https://polygonscan.com/address/0xCb45E82419baeBCC9bA8b1e5c7858e48A3B26Ea6
export const EMERGENCY_ADMIN = '0xCb45E82419baeBCC9bA8b1e5c7858e48A3B26Ea6';

// ICollector https://polygonscan.com/address/0xe8599F3cc5D38a9aD6F3684cd5CEa72f10Dbc383
export const COLLECTOR = '0xe8599F3cc5D38a9aD6F3684cd5CEa72f10Dbc383';

// https://polygonscan.com/address/0x357D51124f59836DeD84c8a1730D72B749d8BC23
export const DEFAULT_INCENTIVES_CONTROLLER = '0x357D51124f59836DeD84c8a1730D72B749d8BC23';

// https://polygonscan.com/address/0x2bB25175d9B0F8965780209EB558Cc3b56cA6d32
export const EMISSION_MANAGER = '0x2bB25175d9B0F8965780209EB558Cc3b56cA6d32';

// https://polygonscan.com/address/0x63dfa7c09Dc2Ff4030d6B8Dc2ce6262BF898C8A4
export const DEBT_SWAP_ADAPTER = '0x63dfa7c09Dc2Ff4030d6B8Dc2ce6262BF898C8A4';

// https://polygonscan.com/address/0x9eCed0293e7B73CFf4a2b4F9C82aAc8346158bd9
export const CONFIG_ENGINE = '0x9eCed0293e7B73CFf4a2b4F9C82aAc8346158bd9';

// https://polygonscan.com/address/0x781978AC59710b5FDd00d5c6a6c3662ba3d85b84
export const MIGRATION_HELPER = '0x781978AC59710b5FDd00d5c6a6c3662ba3d85b84';

// https://polygonscan.com/address/0x3ac4e9aa29940770aeC38fe853a4bbabb2dA9C19
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x3ac4e9aa29940770aeC38fe853a4bbabb2dA9C19';

// https://polygonscan.com/address/0xD05003a24A17d9117B11eC04cF9743b050779c08
export const RATES_FACTORY = '0xD05003a24A17d9117B11eC04cF9743b050779c08';

// https://polygonscan.com/address/0x6D49dC81a1f07a6B1902DC79bc2D408cb9D555d1
export const REPAY_WITH_COLLATERAL_ADAPTER = '0x6D49dC81a1f07a6B1902DC79bc2D408cb9D555d1';

// https://polygonscan.com/address/0x35784a624D4FfBC3594f4d16fA3801FeF063241c
export const SWAP_COLLATERAL_ADAPTER = '0x35784a624D4FfBC3594f4d16fA3801FeF063241c';

// https://polygonscan.com/address/0x645654D59A5226CBab969b1f5431aA47CBf64ab8
export const UI_INCENTIVE_DATA_PROVIDER = '0x645654D59A5226CBab969b1f5431aA47CBf64ab8';

// https://polygonscan.com/address/0x204f2Eb81D996729829debC819f7992DCEEfE7b1
export const UI_POOL_DATA_PROVIDER = '0x204f2Eb81D996729829debC819f7992DCEEfE7b1';

// https://polygonscan.com/address/0x34aa032bC416Cf2CdC45c0C8f065b1F19463D43e
export const WALLET_BALANCE_PROVIDER = '0x34aa032bC416Cf2CdC45c0C8f065b1F19463D43e';

// https://polygonscan.com/address/0xf1e6d4347105138B51E2bacA9A22fA228309ebB1
export const WETH_GATEWAY = '0xf1e6d4347105138B51E2bacA9A22fA228309ebB1';

// https://polygonscan.com/address/0xF93b565c96446afdf8C3D37E6B4781D5d5EDef1C
export const CLINIC_STEWARD = '0xF93b565c96446afdf8C3D37E6B4781D5d5EDef1C';

export const CHAIN_ID = 137;
export const ASSETS = {
  DAI: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    A_TOKEN: '0x27F8D03b3a2196956ED754baDc28D73be8830A6e',
    V_TOKEN: '0x75c4d1Fb84429023170086f06E682DcbBF537b7d',
    INTEREST_RATE_STRATEGY: '0x8844bC72D4E62ee510b0e3F8aa0074a6EE2b47e5',
    ORACLE: '0xC368bAB13A2b46D02c20c28AeBaB79bbE7E067AA',
  },
  USDC: {
    decimals: 6,
    id: 1,
    UNDERLYING: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    A_TOKEN: '0x1a13F4Ca1d028320A707D99520AbFefca3998b7F',
    V_TOKEN: '0x248960A9d75EdFa3de94F7193eae3161Eb349a12',
    INTEREST_RATE_STRATEGY: '0xa5AEE67a828858f2F3C2f28FEAAfe88067851596',
    ORACLE: '0xeAa310d63670b8C36699cE53E3e926b23355F3df',
  },
  USDT0: {
    decimals: 6,
    id: 2,
    UNDERLYING: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    A_TOKEN: '0x60D55F02A771d515e077c9C2403a1ef324885CeC',
    V_TOKEN: '0x8038857FD47108A07d1f6Bf652ef1cBeC279A2f3',
    INTEREST_RATE_STRATEGY: '0xFC508BA50B4B12959A683dfcDf771518c03476b1',
    ORACLE: '0xf44Fee6877F2f1a0b84c8bC49ff4Ec35DF089Ea0',
  },
  WBTC: {
    decimals: 8,
    id: 3,
    UNDERLYING: '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
    A_TOKEN: '0x5c2ed810328349100A66B82b78a1791B101C9D61',
    V_TOKEN: '0xF664F50631A6f0D72ecdaa0e49b0c019Fa72a8dC',
    INTEREST_RATE_STRATEGY: '0x333ce9806e7c152a95a307CB27551Af5ae9D4163',
    ORACLE: '0xA338e0492B2F944E9F8C0653D3AD1484f2657a37',
  },
  WETH: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    A_TOKEN: '0x28424507fefb6f7f8E9D3860F56504E4e5f5f390',
    V_TOKEN: '0xeDe17e9d79fc6f9fF9250D9EEfbdB88Cc18038b5',
    INTEREST_RATE_STRATEGY: '0x636f0761f7309e1b8c07147b8641E22b494e719b',
    ORACLE: '0x0000000000000000000000000000000000000000',
  },
  WPOL: {
    decimals: 18,
    id: 5,
    UNDERLYING: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    A_TOKEN: '0x8dF3aad3a84da6b69A4DA8aeC3eA40d9091B2Ac4',
    V_TOKEN: '0x59e8E9100cbfCBCBAdf86b9279fa61526bBB8765',
    INTEREST_RATE_STRATEGY: '0x62327F44F77Fa40bf054e222eC484dC621Ee4D39',
    ORACLE: '0x327e23A4855b6F663a28c5161541d69Af8973302',
  },
  AAVE: {
    decimals: 18,
    id: 6,
    UNDERLYING: '0xD6DF932A45C0f255f85145f286eA0b292B21C90B',
    A_TOKEN: '0x1d2a0E5EC8E5bBDCA5CB219e649B565d8e5c3360',
    V_TOKEN: '0x1c313e9d0d826662F5CE692134D938656F681350',
    INTEREST_RATE_STRATEGY: '0xae9b3Eb616ed753dcE96C75B6AE30A60Ff9290B4',
    ORACLE: '0xbE23a3AA13038CfC28aFd0ECe4FdE379fE7fBfc4',
  },
  GHST: {
    decimals: 18,
    id: 7,
    UNDERLYING: '0x385Eeac5cB85A38A9a07A70c73e0a3271CfB54A7',
    A_TOKEN: '0x080b5BF8f360F624628E0fb961F4e67c9e3c7CF1',
    V_TOKEN: '0x36e988a38542C3482013Bb54ee46aC1fb1efedcd',
    INTEREST_RATE_STRATEGY: '0xfe72F0c532c4E7cfA65FCbd3B92D926d26Fb73a9',
    ORACLE: '0xe638249AF9642CdA55A92245525268482eE4C67b',
  },
  BAL: {
    decimals: 18,
    id: 8,
    UNDERLYING: '0x9a71012B13CA4d3D0Cdc72A177DF3ef03b0E76A3',
    A_TOKEN: '0xc4195D4060DaEac44058Ed668AA5EfEc50D77ff6',
    V_TOKEN: '0x773E0e32e7b6a00b7cA9daa85dfba9D61B7f2574',
    INTEREST_RATE_STRATEGY: '0xA78F3bc07035422f6f69c3f2B72fcCd0487348FA',
    ORACLE: '0x03CD157746c61F44597dD54C6f6702105258C722',
  },
  DPI: {
    decimals: 18,
    id: 9,
    UNDERLYING: '0x85955046DF4668e1DD369D2DE9f3AEB98DD2A369',
    A_TOKEN: '0x81fB82aAcB4aBE262fc57F06fD4c1d2De347D7B1',
    V_TOKEN: '0x43150AA0B7e19293D935A412C8607f9172d3d3f3',
    INTEREST_RATE_STRATEGY: '0x6405F880E431403588e92b241Ca15603047ef8a4',
    ORACLE: '0xD550Bce1a506F48802C9A4464c64E14A3141cE73',
  },
  CRV: {
    decimals: 18,
    id: 10,
    UNDERLYING: '0x172370d5Cd63279eFa6d502DAB29171933a610AF',
    A_TOKEN: '0x3Df8f92b7E798820ddcCA2EBEA7BAbda2c90c4aD',
    V_TOKEN: '0x780BbcBCda2cdb0d2c61fd9BC68c9046B18f3229',
    INTEREST_RATE_STRATEGY: '0xe80CDBb7115004064BDD62aEe89666d6b4B75921',
    ORACLE: '0x1CF68C76803c9A415bE301f50E82e44c64B7F1D4',
  },
  SUSHI: {
    decimals: 18,
    id: 11,
    UNDERLYING: '0x0b3F868E0BE5597D5DB7fEB59E1CADBb0fdDa50a',
    A_TOKEN: '0x21eC9431B5B55c5339Eb1AE7582763087F98FAc2',
    V_TOKEN: '0x9CB9fEaFA73bF392C905eEbf5669ad3d073c3DFC',
    INTEREST_RATE_STRATEGY: '0x835699Bf98f6a7fDe5713c42c118Fb80fA059737',
    ORACLE: '0x17414Eb5159A082e8d41D243C1601c2944401431',
  },
  LINK: {
    decimals: 18,
    id: 12,
    UNDERLYING: '0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39',
    A_TOKEN: '0x0Ca2e42e8c21954af73Bc9af1213E4e81D6a669A',
    V_TOKEN: '0xCC71e4A38c974e19bdBC6C0C19b63b8520b1Bb09',
    INTEREST_RATE_STRATEGY: '0x01576c429baB8724A11bef844dDa95165D899Fca',
    ORACLE: '0xb77fa460604b9C6435A235D057F7D319AC83cb53',
  },
} as const;
